import { capitalize } from '../utility/StringUtils';
import SettingsModel from './SettingsModel';
import mainPageModel from '../main-navigation/MainPageModel';
import billingDialogModel from './BillingDialogModel';
import { ISort } from '../DataTypes';
import { BillingItemsPanelView } from './BillingItemsPanelView';
import { BillingEditPanelFooterView } from './BillingEditPanelFooterView';

export default class BillingsSettingsModel extends SettingsModel {
  constructor() {
    super('Billing', undefined, billingDialogModel);
    this.ItemsPanelView = BillingItemsPanelView;
    this.EditPanelFooterView = BillingEditPanelFooterView;
  }

  protected async _load(
    _filter?: { search?: string | undefined } | undefined,
    _sort?: ISort | undefined,
  ): Promise<{ cursor?: string | undefined; totalCount: number }> {
    const planInfo = {
      totalCount: 1,
      data: [
        {
          id: mainPageModel.location.id,
          name: capitalize(mainPageModel.location.tier),
          planAdministrator: mainPageModel.location.planAdministrator,
          subscriptionExpires: mainPageModel.location.subscriptionExpires,
          subscriptionCount: mainPageModel.location.subscriptionCount,
          activeUsers: mainPageModel.location.activeUsers,
          employeeCount: mainPageModel.location.employeeCount,
          activeEmployees: mainPageModel.location.activeEmployees,
        },
      ],
    };
    this.setItems(planInfo.data);
    return planInfo;
  }

  get access(): boolean {
    return mainPageModel.canViewBilling;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canEditBilling;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditBilling;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canEditBilling;
  }

  get hiddenGridColumns(): string[] {
    return ['code', 'tags'];
  }

  getDefaultEditPanelHeaderOptionsItems() {
    return [];
  }
}
